import { createAction, props } from '@ngrx/store';
import { UserState } from './user-state.model';

export const updateAllState = createAction('[User] Update all state of user', props<{ user: UserState }>());
export const clear = createAction('[User] Clear');
